import { QueryClient, useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { messageError, messagePending, messageSuccess } from "../../../services/messages"
import { apiErrorMessage } from "../../../services/apiErrorText"
import { createKey, deleteKey, updateKey } from "./apiCalls"
import { KeycollectionType } from "../../Objekte/types/types"

// create a new key
export const useCreateKeyMutation = (queryClient: QueryClient, invalidateKey?: string | string[]) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { body: any }>({
        mutationFn: ({ body }) => createKey(body),
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Schlüssel wird gerade erstellt.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Der Schlüssel wurde erfolgreich erstellt.")
            if (invalidateKey) {
                queryClient.invalidateQueries({ queryKey: Array.isArray(invalidateKey) ? invalidateKey : [invalidateKey] })
            }
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Schlüssel konnte nicht erstellt werden."))
            console.log(err)
        },
    })
    return mutation
}

// hand out a key (update owner, signature, append history)
export const useUpdateKeyMutation = (queryClient: QueryClient, invalidateKey?: string | string[]) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { id: string; body: KeycollectionType }>({
        mutationFn: (variables) => updateKey(variables.body, variables.id),
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Schlüssel wird gerade aktualisiert.")
        },
        onSuccess: (data, variables) => {
            messageSuccess(notificationKey, "Fertig!", "Der Schlüssel wurde erfolgreich aktualisiert.")
            if (invalidateKey) {
                queryClient.invalidateQueries({ queryKey: Array.isArray(invalidateKey) ? invalidateKey : [invalidateKey] })
            }
            // also try to invalidate specific single key cache if used elsewhere
            queryClient.invalidateQueries({ queryKey: ["singleKeyData" + variables.id] })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Schlüssel konnte nicht aktualisiert werden."))
            console.log(err)
        },
    })
    return mutation
}

// delete a key
export const useDeleteKeyMutation = (queryClient: QueryClient, invalidateKey?: string | string[]) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, string>({
        mutationFn: (variables) => deleteKey(variables),
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Schlüssel wird gerade gelöscht.")
        },
        onSuccess: (data, variables) => {
            messageSuccess(notificationKey, "Fertig!", "Der Schlüssel wurde erfolgreich gelöscht.")
            if (invalidateKey) {
                queryClient.invalidateQueries({ queryKey: Array.isArray(invalidateKey) ? invalidateKey : [invalidateKey] })
            }
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Schlüssel konnte nicht gelöscht werden."))
            console.log(err)
        },
    })
    return mutation
}



